import { render } from "./IconRemoveCircle.vue?vue&type=template&id=6369cf2e"
import script from "./IconRemoveCircle.vue?vue&type=script&lang=js"
export * from "./IconRemoveCircle.vue?vue&type=script&lang=js"

import exportComponent from "../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__